const siphoxReport = {
  client: {
    id: 448,
    email: 'spollock24@gmail.com',
    lab_customer_id: '694f4c361be61b2b6c38a6bb',
    shopify_customer_id: '9567967772965',
    created_at: '2025-12-27T03:02:06.064Z',
    first_name: 'Samantha',
    last_name: 'Pollock',
    gender: 'F',
    birthday: '1984-01-10T00:00:00.000Z',
    age: 42,
  },
  axes: [
    {
      axis: 'Metabolic Health',
      category: 'biomarker',
      result: 'N/A',
      historic: [],
      range: 'notAvailable',
      usersAverage: 82,
      description:
        'Metabolic health is key to energy regulation and overall well-being. Dysregulation in glucose, insulin, or lipid metabolism can lead to conditions like diabetes, obesity, and other chronic diseases.',
      infoLink: '',
    },
    {
      axis: 'Hormonal Health',
      category: 'biomarker',
      result: 80,
      historic: [
        {
          result: 80,
          timestamp: '2026-02-05T15:01:55-05:00',
          reportType: 'SPOT_REPORT',
          kitType: 'ADX3GUYOV1',
          spotID: 'SPRYYW1QQH',
        },
      ],
      range: 'inRange',
      usersAverage: 78,
      description:
        'Hormonal Health is fundamental for hormonal balance, fertility, and overall well-being. Hormonal imbalances can impact energy, mood, and reproductive function, contributing to various health challenges.',
      infoLink: '',
    },
    {
      axis: 'Thyroid Health',
      category: 'biomarker',
      result: 95,
      historic: [
        {
          result: 95,
          timestamp: '2026-02-05T15:01:55-05:00',
          reportType: 'SPOT_REPORT',
          kitType: 'ADX3GUYOV1',
          spotID: 'SPRYYW1QQH',
        },
      ],
      range: 'optimal',
      usersAverage: 80,
      description:
        'Thyroid health is essential for regulating metabolism, energy production, and overall hormonal balance. Dysfunction in thyroid activity can lead to imbalances affecting energy levels, weight, and overall well-being.',
      infoLink: '',
    },
  ],
  biomarker: [
    {
      simpleLabel: 'Testosterone, Free (calc)',
      ranges: {
        fair: [],
        optimal: [],
        inRange: [0.5, 6],
        good: [0.5, 6],
      },
      result: 6.3,
      rawResult: 6.3,
      type: 'biomarker',
      unit: 'pg/mL',
      originalUnit: 'ng/mL',
      label: 'Testosterone, Free (calc)',
      shortLabel: 'Testosterone, Free (calc)',
      targetType: 'high',
      infoLink: '',
      category: {
        name: 'Hormonal Health',
        weight: 0.05,
      },
      deviationScore: 23.636363636363637,
      historic: [
        {
          result: 3.4,
          rawResult: 3.4,
          timestamp: '2026-02-05T15:01:55-05:00',
          ranges: {
            fair: [],
            optimal: [],
            inRange: [0.5, 6],
            good: [0.5, 6],
          },
          siphoxRange: 'good',
          reportType: 'SPOT_REPORT',
          kitType: 'ADX3GUYOV1',
          spotID: 'SPRYYW1QQH',
        },
      ],
      state: 'default',
      labRange: 'inRange',
      siphoxRange: 'good',
      nonUpperRanged: true,
    },
    {
      simpleLabel: 'Testosterone, Total (Females)',
      ranges: {
        fair: [],
        optimal: [],
        inRange: [0, 75],
        good: [0, 75],
      },
      result: 24,
      rawResult: 24,
      type: 'biomarker',
      unit: 'ng/dL',
      originalUnit: 'ng/mL',
      label: 'Testosterone, Total (Females)',
      shortLabel: 'Testosterone, Total (Fe)',
      targetType: 'range',
      infoLink: 'https://siphoxhealth.com/hub/biomarkers-2/biomarker-testosterone/',
      category: {
        name: 'Hormonal Health',
        weight: 0.05,
      },
      deviationScore: 9,
      historic: [
        {
          result: 24,
          rawResult: 24,
          timestamp: '2026-02-05T15:01:55-05:00',
          ranges: {
            fair: [],
            optimal: [],
            inRange: [0, 75],
            good: [0, 75],
          },
          siphoxRange: 'good',
          reportType: 'SPOT_REPORT',
          kitType: 'ADX3GUYOV1',
          spotID: 'SPRYYW1QQH',
        },
      ],
      state: 'default',
      labRange: 'inRange',
      siphoxRange: 'good',
    },
    {
      simpleLabel: 'Anti-Mullerian Hormone (AMH)',
      ranges: {
        fair: [],
        optimal: [],
        inRange: [0.01, 2.99],
        good: [0.82, 14.63],
      },
      result: 0,
      rawResult: 0,
      type: 'biomarker',
      unit: 'ng/mL',
      originalUnit: 'ng/mL',
      label: 'Anti-Mullerian Hormone (AMH)',
      shortLabel: 'AMH',
      targetType: 'range',
      infoLink: 'https://siphoxhealth.com/hub/biomarkers-2/biomarker-anti-mullerian-hormone-amh/',
      category: {
        name: 'Hormonal Health',
        weight: 0.2,
      },
      deviationScore: 0.5033557046979907,
      historic: [
        {
          result: 1.47,
          rawResult: 1.47,
          timestamp: '2026-02-05T15:01:55-05:00',
          ranges: {
            fair: [],
            optimal: [],
            inRange: [0.01, 2.99],
            good: [0.82, 14.63],
          },
          siphoxRange: 'good',
          reportType: 'SPOT_REPORT',
          kitType: 'ADX3GUYOV1',
          spotID: 'SPRYYW1QQH',
        },
      ],
      state: 'default',
      labRange: 'inRange',
      siphoxRange: 'good',
    },
    {
      simpleLabel: 'Prolactin (PRL)',
      ranges: {
        fair: [],
        optimal: [],
        inRange: [3.34, 26.72],
        good: [2.74, 26.72],
      },
      result: 2.12,
      rawResult: 2.12,
      type: 'biomarker',
      unit: 'ng/mL',
      originalUnit: 'ng/mL',
      label: 'Prolactin (PRL)',
      shortLabel: 'PRL',
      targetType: 'range',
      infoLink: 'https://siphoxhealth.com/hub/biomarkers-2/biomarker-prolactin-prl/',
      category: {
        name: 'Hormonal Health',
        weight: 0.05,
      },
      deviationScore: 21.19332763045338,
      historic: [
        {
          result: 5.12,
          rawResult: 5.12,
          timestamp: '2026-02-05T15:01:55-05:00',
          ranges: {
            fair: [],
            optimal: [],
            inRange: [3.34, 26.72],
            good: [2.74, 26.72],
          },
          siphoxRange: 'good',
          reportType: 'SPOT_REPORT',
          kitType: 'ADX3GUYOV1',
          spotID: 'SPRYYW1QQH',
        },
      ],
      state: 'default',
      labRange: 'inRange',
      siphoxRange: 'good',
    },
    {
      simpleLabel: 'Thyroid Stimulating Hormone (TSH)',
      ranges: {
        fair: [0.45, 5.33],
        optimal: [1, 2],
        inRange: [0.45, 5.33],
        good: [0.45, 2.5],
      },
      result: 1.13,
      rawResult: 1.13,
      type: 'biomarker',
      unit: 'uIU/mL',
      originalUnit: 'uIU/mL',
      label: 'Thyroid Stimulating Hormone (TSH)',
      shortLabel: 'TSH',
      targetType: 'range',
      infoLink: 'https://siphoxhealth.com/hub/biomarkers-2/biomarker-thyroid-stimulating-hormone-tsh/',
      category: {
        name: 'Thyroid Health',
        weight: 0.4,
      },
      deviationScore: 3.6065573770491812,
      historic: [
        {
          result: 1.13,
          rawResult: 1.13,
          timestamp: '2026-02-05T15:01:55-05:00',
          ranges: {
            fair: [0.45, 5.33],
            optimal: [1, 2],
            inRange: [0.45, 5.33],
            good: [0.45, 2.5],
          },
          siphoxRange: 'optimal',
          reportType: 'SPOT_REPORT',
          kitType: 'ADX3GUYOV1',
          spotID: 'SPRYYW1QQH',
        },
      ],
      state: 'default',
      labRange: 'inRange',
      siphoxRange: 'optimal',
    },
    {
      simpleLabel: 'Free Thyroxine (Free T4)',
      ranges: {
        fair: [0.7, 1.48],
        optimal: [1.1, 1.48],
        inRange: [0.59, 1.22],
        good: [0.9, 1.48],
      },
      result: 1.23,
      rawResult: 1.23,
      type: 'biomarker',
      unit: 'ng/dL',
      originalUnit: 'ng/dL',
      label: 'Free Thyroxine (Free T4)',
      shortLabel: 'T4 (free)',
      targetType: 'range',
      infoLink: 'https://siphoxhealth.com/hub/biomarkers-2/biomarker-free-t4/',
      category: {
        name: 'Thyroid Health',
        weight: 0.2,
      },
      deviationScore: 5.158730158730158,
      historic: [
        {
          result: 1.23,
          rawResult: 1.23,
          timestamp: '2026-02-05T15:01:55-05:00',
          ranges: {
            fair: [0.7, 1.48],
            optimal: [1.1, 1.48],
            inRange: [0.59, 1.22],
            good: [0.9, 1.48],
          },
          siphoxRange: 'optimal',
          reportType: 'SPOT_REPORT',
          kitType: 'ADX3GUYOV1',
          spotID: 'SPRYYW1QQH',
        },
      ],
      state: 'default',
      labRange: 'outOfRange',
      siphoxRange: 'optimal',
    },
    {
      simpleLabel: 'Sex Hormone-Binding Globulin (SHBG)',
      ranges: {
        fair: [],
        optimal: [],
        inRange: [18.2, 135.5],
        good: [16.8, 135.5],
      },
      result: 44.9,
      rawResult: 44.9,
      type: 'biomarker',
      unit: 'nmol/L',
      originalUnit: 'nmol/L',
      label: 'Sex Hormone-Binding Globulin (SHBG)',
      shortLabel: 'SHBG',
      targetType: 'range',
      infoLink: 'https://siphoxhealth.com/hub/biomarkers-2/biomarker-sex-hormone-binding-globulin-shbg/',
      category: {
        name: 'Hormonal Health',
        weight: 0.05,
      },
      deviationScore: 13.618925831202045,
      historic: [
        {
          result: 44.9,
          rawResult: 44.9,
          timestamp: '2026-02-05T15:01:55-05:00',
          ranges: {
            fair: [],
            optimal: [],
            inRange: [18.2, 135.5],
            good: [16.8, 135.5],
          },
          siphoxRange: 'good',
          reportType: 'SPOT_REPORT',
          kitType: 'ADX3GUYOV1',
          spotID: 'SPRYYW1QQH',
        },
      ],
      state: 'default',
      labRange: 'inRange',
      siphoxRange: 'good',
    },
    {
      simpleLabel: 'Albumin',
      ranges: {
        fair: [3.5, 5.7],
        optimal: [4, 5],
        inRange: [3.5, 5.7],
        good: [3.5, 5],
      },
      result: 4.99,
      rawResult: 4.99,
      type: 'biomarker',
      unit: 'g/dL',
      originalUnit: 'g/dL',
      label: 'Albumin',
      shortLabel: 'Albumin',
      targetType: 'range',
      infoLink: 'https://siphoxhealth.com/hub/biomarkers-2/biomarker-albumin/',
      category: {
        name: 'Metabolic Health',
        weight: 0.05,
      },
      deviationScore: 1.7727272727272751,
      historic: [
        {
          result: 4.99,
          rawResult: 4.99,
          timestamp: '2026-02-05T15:01:55-05:00',
          ranges: {
            fair: [3.5, 5.7],
            optimal: [4, 5],
            inRange: [3.5, 5.7],
            good: [3.5, 5],
          },
          siphoxRange: 'optimal',
          reportType: 'SPOT_REPORT',
          kitType: 'ADX3GUYOV1',
          spotID: 'SPRYYW1QQH',
        },
      ],
      state: 'default',
      labRange: 'inRange',
      siphoxRange: 'optimal',
    },
    {
      simpleLabel: 'TSH:T4 Ratio',
      ranges: {
        fair: [0.5, 1.5],
        optimal: [0.6, 1.2],
        inRange: [0.5, 1.5],
        good: [0.6, 1.4],
      },
      result: 0.91,
      rawResult: 0.91,
      type: 'biomarker',
      unit: '',
      label: 'TSH:T4 Ratio',
      shortLabel: 'TSH:T4 Ratio',
      targetType: 'range',
      infoLink: '',
      category: {
        name: 'Thyroid Health',
        weight: 0,
      },
      deviationScore: 0.8999999999999997,
      historic: [
        {
          result: 0.91,
          rawResult: 0.91,
          timestamp: '2026-02-05T15:01:55-05:00',
          ranges: {
            fair: [0.5, 1.5],
            optimal: [0.6, 1.2],
            inRange: [0.5, 1.5],
            good: [0.6, 1.4],
          },
          siphoxRange: 'optimal',
          reportType: 'SPOT_REPORT',
          kitType: 'ADX3GUYOV1',
          spotID: 'SPRYYW1QQH',
        },
      ],
      state: 'default',
      labRange: 'inRange',
      siphoxRange: 'optimal',
    },
  ],
  wearable: [],
  suggestions: [],
  actionsState: [],
  unknownBiomarkers: [],
  incorrectUnitBiomarkers: [],
  missingMarkers: [],
  details: {
    collectedDate: '2026-02-05T20:01:55.579Z',
    resultedDate: '2026-02-10T15:01:15.259Z',
  },
  kitType: 'perimenopause',
};
